import Vue    from 'vue'
import Router from 'vue-router'
import Main   from './components/Main.vue'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'main',
    component: Main
  }, {
    path: '/rbs',
    name: 'rbs',
    component: () => import('@/components/WaterEnergy.vue')
  }, {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/components/Dashboard2.vue')
  }, {
    path: '/calendar',
    name: 'calendar',
    component: () => import('@/components/CalendarMain.vue')
  }, {
    path: '/kendeda',
    name: 'kendeda',
    component: () => import('@/components/WaterEnergyKendeda.vue')
  }, {
    path: '/kendedaDTW',
    name: 'kendedaDTW',
    component: () => import('@/components/KendedaDTW.vue')
  }]
})
